module.exports = "/_next/static/resources/life2-f84c36d2442588cc556eac3388c6b580.webp";